module.exports = "/assets/restaurant-festival-menu/banner_drinks_cola.png?OnHgJvB";